/**
 * RELIVE COUTURE — Theme JavaScript
 * Mobile Nav · Header Scroll · Gallery · Accordion · ATC
 * Cart-Drawer wird von snippets/cart-drawer.liquid bereitgestellt (window.rcCartDrawer)
 */

'use strict';

document.addEventListener('DOMContentLoaded', function () {
  RCTheme.init();
});

const RCTheme = {
  init() {
    this.cartTriggers();
    this.mobileNav();
    this.headerScroll();
    this.scrollAnimations();
    this.productGallery();
    this.productAccordion();
    this.filterButtons();

    // Im Theme-Editor werden Sektionen dynamisch nachgeladen -> Galerie neu verdrahten
    document.addEventListener('shopify:section:load', () => {
      this.productGallery();
    });
  },

  // ── Cart Triggers (Öffnet neuen Drawer aus snippets/cart-drawer.liquid) ──
  cartTriggers() {
    document.querySelectorAll('[data-open-cart]').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.rcCartDrawer) {
          window.rcCartDrawer.refresh();
          window.rcCartDrawer.open();
        }
      });
    });
  },

  // ── Helper: Cart-Count-Badge aktualisieren ──
  updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  // ── Mobile Nav ──
  mobileNav() {
    const nav     = document.getElementById('rc-mobile-nav');
    const toggle  = document.getElementById('rc-mobile-nav-toggle');
    const close   = document.getElementById('rc-mobile-nav-close');
    const overlay = nav && nav.querySelector('.rc-mobile-nav__overlay');

    if (!nav || !toggle) return;

    const open     = () => { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const closeNav = () => { nav.classList.remove('is-open'); document.body.style.overflow = ''; };

    toggle.addEventListener('click', open);
    close && close.addEventListener('click', closeNav);
    overlay && overlay.addEventListener('click', closeNav);
  },

  // ── Sticky Header shadow ──
  headerScroll() {
    const header = document.getElementById('rc-header');
    if (!header) return;
    const update = () => {
      header.classList.toggle('rc-header--scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  },

  // ── Intersection Observer fade-ups ──
  scrollAnimations() {
    const reveal = (root) => {
      const scope = root && root.querySelectorAll ? root : document;
      const els = scope.querySelectorAll('.rc-fade-up:not(.is-visible)');
      if (!els.length) return;

      if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
        els.forEach(el => el.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

      els.forEach(el => observer.observe(el));
    };

    reveal(document);
    document.addEventListener('shopify:section:load', (e) => reveal(e.target));
  },

  // ── Product Gallery ──
  productGallery() {
    const mainImg = document.getElementById('rc-gallery-main-img');
    const thumbs  = document.querySelectorAll('[data-thumb]');

    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(thumb => {
      if (thumb._rcGalleryBound) return;
      thumb._rcGalleryBound = true;

      thumb.addEventListener('click', function () {
        const src = this.dataset.thumb;
        const alt = this.dataset.alt || '';

        thumbs.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');

        mainImg.classList.add('is-loading');
        const tempImg = new Image();
        tempImg.src = src;
        tempImg.onload = () => {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
          mainImg.alt = alt;
          mainImg.classList.remove('is-loading');
        };
      });
    });
  },

  // ── Product Accordion ──
  productAccordion() {
    document.querySelectorAll('.rc-accordion__trigger').forEach(trigger => {
      trigger.addEventListener('click', function () {
        const accordion = this.closest('.rc-accordion');
        const isOpen    = accordion.classList.contains('is-open');

        document.querySelectorAll('.rc-accordion.is-open').forEach(a => {
          if (a !== accordion) a.classList.remove('is-open');
        });

        accordion.classList.toggle('is-open', !isOpen);
      });
    });

    const first = document.querySelector('.rc-accordion');
    if (first) first.classList.add('is-open');
  },

  // ── Add to Cart (nutzt neuen Cart-Drawer) ──
  addToCart(variantId, productTitle) {
    const btn = document.getElementById('rc-atc-btn');
    if (!btn) return;

    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => {
      btn.textContent = '✓ Im Warenkorb';
      btn.classList.add('rc-btn--added');

      // Cart-Count im Header aktualisieren
      this.updateCartCount(cart.item_count);

      // Neuen Drawer befuellen + oeffnen
      if (window.rcCartDrawer) {
        window.rcCartDrawer.render(cart);
        window.rcCartDrawer.open();
      }

      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = 'In den Warenkorb';
        btn.classList.remove('rc-btn--added');
      }, 2500);
    })
    .catch(err => {
      console.error('ATC error:', err);
      btn.disabled = false;
      btn.textContent = 'Fehler — nochmal versuchen';
    });
  },

  // ── Filter Buttons (Collection Page) ──
  filterButtons() {
    const btns = document.querySelectorAll('[data-filter-btn]');
    btns.forEach(btn => {
      btn.addEventListener('click', function () {
        const group = this.dataset.filterGroup;
        document.querySelectorAll(`[data-filter-btn="${group}"]`).forEach(b => {
          b.classList.remove('is-active');
        });
        this.classList.add('is-active');
        const url = new URL(window.location);
        const filterKey = this.dataset.filterKey;
        const filterVal = this.dataset.filterValue;
        if (filterVal === 'all') {
          url.searchParams.delete(filterKey);
        } else {
          url.searchParams.set(filterKey, filterVal);
        }
        window.location.href = url.toString();
      });
    });
  }
};

window.RCTheme = RCTheme;
